import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import StandardInsights from "./routes/StandardInsights";
import UnitInsights from "./routes/UnitInsights";
import PlannerElementInsights from "./routes/PlannerElementInsights";
import SyllabusInsights from "./routes/SyllabusInsights";
import TimelineInsights from "./routes/TimelineInsights";
import Connections from "./routes/Connections";

import ProgrammeOfInquiry from "CurriculumInsights/routes/VerticalInsights/routes/ProgrammeOfInquiry";

export default store => ({
  path: ":elementId",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(
        /* webpackChunkName: "generic-insights-elements" */ "./components"
      ),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;
      return component;
    })
  ),
  childRoutes: [
    UnitInsights(store),
    StandardInsights(store),
    TimelineInsights(store),
    Connections(store),
    ProgrammeOfInquiry(store),
    SyllabusInsights(store),
    PlannerElementInsights(store),
  ],
});
